import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../../../environments/environment';
import { ProductosInformacionResInterface } from '../../../interfaces/producto-informacion.interface';

@Injectable({
  providedIn: 'root'
})
export class ProductosInformacionService {
  /**
   * @description constructor
   * @params http
   */
  constructor(
    private http: HttpClient
  ) {
    this.http = http;
  }

  /**
   * Obtiene la información de un producto por su identificador.
   *
   * @param id Identificador del producto.
   * @returns Observable<ProductosInformacionResInterface> con la información del producto.
   *
   * @example
   * // Ejemplo de uso:
   * this.productosInformacionService.getProductInfo(17084).subscribe(res => {
   *   // res es de tipo ProductosInformacionResInterface
   * });
   *
   * // La URL generada será:
   * // https://<host>/productos/<idProducto>?idPortal=1
   */
  getProductInfo(id: number): Observable<ProductosInformacionResInterface> {
    const httpOpt = {
      headers: new HttpHeaders()
      .append('Content-Type', 'application/x-www-form-urlencoded'),
      params: { idPortal: '1' }
    };

    return this.http.get<ProductosInformacionResInterface>(
      environment.endpoints.urlBase +
      environment.endpoints.productosInformacion.name +
      `${id}`,
      httpOpt
    );
  }
}
